import {ArticleStatus} from "@/modules/articles/articles-table/types";

export interface Tag {
  id: number,
  label: string,
  service_type_id: number | null,
}

export interface ArticleTag {
  id: number,
  label: string,
}

export interface ArticleDetail {
  id: number,
  title: string | null,
  summary: string | null,
  body: string | null,
  status: ArticleStatus,
  tags: ArticleTag[],
  slug: string | null,
  approved_at: string | null,
  created_at: string | null,
  updated_at: string | null,
  is_published_to_advisers: boolean,
}

export interface SubmitForReviewArticle {
  id: number,
  status: ArticleStatus,
  title: string | null | undefined,
  summary: string | null | undefined,
  body: string | null | undefined,
}

export interface ArticleFormValues {
  title: string,
  summary: string,
  body: string,
  tagIds: number[],
}

export const ARTICLE_BODY_MIN_CHARS = 100

export const ARTICLE_MAX_TAGS = 4

export const ARTICLE_TITLE_MAX_LENGTH = 60

export const ARTICLE_SUMMARY_MAX_LENGTH = 160

export const ARTICLE_URL_PATTERN = /https?:\/\/\S+/i

export const STANDARDS_CONFIRMATION_LABEL = 'I confirm that this article is accurate, does not constitute regulated ' +
  'financial advice, and meets the VouchedFor publishing standards.'

export const REVIEW_SUBMISSION_EXPLANATION = 'Each article will be reviewed and approved by a member of the Vouchedfor team before it is published on site. This will be processed within a week.'
